import { useState } from 'react';

const FilesViewer = ({ showfile }) => {
    const [currentFileIndex, setCurrentFileIndex] = useState(0);

    if (!showfile || showfile.length === 0) return null;

    const currentFile = showfile[currentFileIndex];

    return (
        <div className="mt-4">
            <div className="flex gap-2 mb-4 border-b pb-2 overflow-x-auto max-w-[60rem]">
                {showfile.map((file, index) => (
                    <button
                        key={file.id || index}
                        onClick={() => setCurrentFileIndex(index)}
                        className={`px-3 py-1 rounded-t-lg whitespace-nowrap border text-sm flex-shrink-0 ${currentFileIndex === index
                            ? 'bg-blue-100 border-blue-300 border-b-white -mb-[1px]'
                            : 'bg-gray-100 border-gray-300 hover:bg-gray-200'
                            }`}
                    >
                        {file.filename}
                    </button>
                ))}
            </div>

            <div className="border rounded-md overflow-hidden h-[500px]">
                <iframe
                    src={currentFile.filepathurl}
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                    title={currentFile.filename}
                    type="application/pdf"
                />
            </div>
        </div>
    )
}

export default FilesViewer;